import { useEffect, useState } from 'react'

function formatSeconds(total) {
  const s = Math.max(0, Math.floor(total))
  const m = Math.floor(s / 60)
  const r = s % 60
  return `${m}:${String(r).padStart(2, '0')}`
}

/**
 * Countdown seeded from a server duration (seconds).
 * Pass `expiresIn` from the API — never invent a client-side default window.
 */
export default function Countdown({ expiresIn, startedAt, onExpire, label = 'Code expires in' }) {
  const [remaining, setRemaining] = useState(() => {
    if (expiresIn == null || !Number.isFinite(Number(expiresIn))) return null
    const elapsed = startedAt ? (Date.now() - startedAt) / 1000 : 0
    return Math.max(0, Number(expiresIn) - elapsed)
  })

  useEffect(() => {
    if (expiresIn == null || !Number.isFinite(Number(expiresIn))) {
      setRemaining(null)
      return undefined
    }
    const tick = () => {
      const elapsed = startedAt ? (Date.now() - startedAt) / 1000 : 0
      const left = Math.max(0, Number(expiresIn) - elapsed)
      setRemaining(left)
      if (left <= 0 && onExpire) onExpire()
    }
    tick()
    const id = setInterval(tick, 250)
    return () => clearInterval(id)
  }, [expiresIn, startedAt, onExpire])

  if (remaining == null) return null

  return (
    <p className="countdown" aria-live="polite">
      {remaining > 0 ? (
        <>
          {label} <strong>{formatSeconds(remaining)}</strong>
        </>
      ) : (
        <span>Code expired</span>
      )}
    </p>
  )
}

export function useResendGate(resendAfter, startedAt) {
  const [remaining, setRemaining] = useState(() => {
    if (resendAfter == null || !Number.isFinite(Number(resendAfter))) return 0
    const elapsed = startedAt ? (Date.now() - startedAt) / 1000 : 0
    return Math.max(0, Number(resendAfter) - elapsed)
  })

  useEffect(() => {
    if (resendAfter == null || !Number.isFinite(Number(resendAfter))) {
      setRemaining(0)
      return undefined
    }
    const tick = () => {
      const elapsed = startedAt ? (Date.now() - startedAt) / 1000 : 0
      setRemaining(Math.max(0, Number(resendAfter) - elapsed))
    }
    tick()
    const id = setInterval(tick, 250)
    return () => clearInterval(id)
  }, [resendAfter, startedAt])

  return remaining
}
